<div [formGroup]="mainForm" id="top">
  <app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray" />
  <h1>口座振替依頼返却内訳表出力</h1>
  <app-sgkd010d-search-condition
    (responseEmitter)="setResult($event)"
    (clearMessageEvent)="clearMessage()"
  />
  <app-sgkd010d-search-result
    (clearMessageEvent)="clearMessage()"
    (setMessageEvent)="pushSgAriaMessage($event)"
  />
</div>
